module.exports = __webpack_public_path__ + "media/images/prev-0edc57cc.png";